import Requests from '@/helpers/Request';
import Vue from 'vue';
import { toJson, eventlist, groupByHorizontalPages, getEpgForPage, highlightFirstProgram, sortAndFilterChannels, addPageNrToChannels } from '@/helpers/EpgGuide'

export default {
  namespaced: true,
  state: () => ({
    tvPackageLoaded: false,
    tvPackageData: {},
    tvChannelData: {}, // obsolete
    tvChannels: [],
    pool: [],
    programs: [], // for current page
    programsByPages: [],
    tvStartChannel: 0
  }),
  mutations: {
    tvPackage(state, tvPackageData) {
      state.tvPackageData = tvPackageData;
    },
    tvChannels(state, {channels}) {
      for (const item of channels) {
        if (item.serviceType !== "tv") continue;
        Vue.set(state.tvChannelData, item.position, item);
      }
    },
    tvChannelsSort(state, channels) {
      state.tvChannels = addPageNrToChannels(sortAndFilterChannels(channels));
    },
    // contains 15h epg data
    epgPool(state, pool) {
      state.pool = pool;
    },
    programs(state, programs) {
      state.programs = programs;
    },
    programsByPages(state, programsByPages) {
      state.programsByPages = programsByPages;
    },
    tvStartChannel(state, tvStartChannel) {
      state.tvStartChannel = tvStartChannel;
    },
  },
  actions: {
    async init({ commit, dispatch, rootState, state}) {
      try {
        //commit('programs',[]); // delete old programs

        const response = await Requests.fetchTvPackages({
          deviceId: rootState.deviceId
          //deviceId: "6229f71474db4a1b2bf0f7b5"
        });
        /*const response = await Requests.fetchChannelList({
          bid: rootState.buildingId,
        });*/
        commit('tvPackage', response);
        commit('tvChannels', response.package) // obsolete
        commit('tvChannelsSort', response.package)

        // fetch
        const responseEpg = await Requests.fetchEpgByChannels({
          channels: state.tvChannels
        });

        // convert xml to json
        const epgJson = responseEpg.map(item => toJson(item))
        commit('epgPool', epgJson);

        // create program list for page

        commit('programsByPages',[]); // delete old programs
        const programsByPages = epgJson.map((epg, index) => groupByHorizontalPages(epg, index, new Date()));

        commit('programsByPages', programsByPages);

        const p1 = getEpgForPage(1, programsByPages)
        const epgPage1 = p1.map((epg, index) => eventlist(epg, index, 1));

        highlightFirstProgram(epgPage1, state.tvStartChannel);

        console.log("epgPage1: ", epgPage1);
        commit('programs',[]); // delete old programs
        commit('programs', epgPage1);

        return Promise.resolve();
      } catch (err) {
          console.log("Error in init epg guide: ", err);
        return Promise.reject();
      }
    },
  },
  getters: {
    tvChannels(state) {
      console.log('state tvChannels', state)
      return state.tvChannels;
    },
    tvPrograms(state) {
      console.log('state tvPrograms', state)
      return state.programs;
    },
    tvStartChannel(state) {
      return state.tvStartChannel;
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/epg-guide.js